import React, {useState} from "react"
import {Form} from "react-bootstrap"
import {Controller, useForm} from "react-hook-form";
import {useNavigate} from "react-router";
import DescriptionField from "../../../../components/common/description-field/DescriptionField";
import ThemeButton from "../../../../components/common/theme-button/ThemeButton";
import {checkEmptySpaces, maxLength, Required} from "../../../../utils/patterns";
import {CloseRoundedCheck, RoundedCheck} from "../../../../../assets/icons/defaultIcons";
import {notification} from "antd";
import EditGratitudeSkeleton from "../../../skeletons/gratitude/EditGratitudeSkeleton";
import {UpdateGoals} from "../../../../services/goals";
import EditQuestSkeleton from "../../../skeletons/quest/EditQuestSkeleton";

export default function EditTarget({close, getListing, setGetListing, data}) {
    const[loader,setLoader] = useState(false);
    const[question,setQuestion] = useState(false);
    const [singleGratitudeData, setSingleGratitudeData] = useState(false)
    console.log(data, 'data edit goal')
    const {
        handleSubmit,
        reset,
        setValue,
        formState: {errors, isValid},
        control,
        clearErrors
    } = useForm({
        mode: 'onChange',
    })
    const navigate = useNavigate()

    const onSubmit = async (formData) => {
        setLoader(true)

        if(formData){
            let payload = {
                goal: formData.des,
                isDone: data?.isDone,
                categroy: data?.category
            }
            const response = await UpdateGoals(data?._id,payload)

            if (response?.data?.data?.status){
                notification.success({
                    message: "Success",
                    description: "Goal updated successfully",
                    placement: "topRight",
                    icon: <RoundedCheck/>,
                    duration: 2,
                });
                setGetListing(!getListing)
                close(false)
                setLoader(false)
            }
            else{
                notification.error({
                    message: "Failed",
                    description: "Login failed. Please check your credentials !",
                    placement: "topRight",
                    icon: <CloseRoundedCheck/>,
                    duration: 2,
                });
                close(false)
            }

        }

    }

    if(loader){
        return <EditQuestSkeleton/>
    }

    return(
        <div className={'add-gratitude'}>
            <Form onSubmit={handleSubmit(onSubmit)}>
                <div className={'dfields'}>
                    <Controller
                        name="des"
                        defaultValue={data?.goal}
                        control={control}
                        rules={{required:Required, maxLength: maxLength(2000) , validate:checkEmptySpaces}}
                        render={({field: {name, ...field}}) => (
                            <DescriptionField
                                placeholder={'Write your text here'}
                                type={'text'}
                                field={field}
                                defaultValue={data?.goal}
                                errors={errors.des}
                                autoSize={{ minRows: 1, maxRows: 1 }}
                            />
                        )}
                    />
                </div>
                <div className={'mt-30'}>
                    <ThemeButton
                        text={'Update'}
                        type={'submit'}
                        className={'btn-light-lg'}
                        loader={loader}
                    />
                </div>
            </Form>
        </div>
    )
}